module.exports = __webpack_public_path__ + "cc69e0338ff4c6ac5c724c1b1f739f54.jpg";